export interface IStepConfig {
    id: string;
    name: string;
    width?: string;
}

export const WIZARD_STEPS: IStepConfig[] = [
    {
        id: "countries",
        name: "countries",
        width: "712px",
    },
    {
        id: "keywords",
        name: "keywords",
        width: "712px",
    },
    {
        id: "campaign_name",
        name: "campaign_name",
        width: "492px",
    },
];

export const steps = {
    COUNTRIES: "countries",
    KEYWORDS: "keywords",
    CAMPAIGN_NAME: "campaign_name",
} as const;

export type StepType = (typeof steps)[keyof typeof steps];

export interface IKeywordsStats {
    totalCount: number;
    uniqueKeywords: string[];
    keywordSources: Record<string, string>;
    hasDuplicates: boolean;
}
